module.exports = __webpack_public_path__ + "static/media/mobileScreenshot12.26bc0731.jpg";